import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export type AppSettings = {
  refreshCooldownMs: number;
  showFirestoreIds: boolean;
  requestStallMs: number;
};

export const DEFAULT_APP_SETTINGS: AppSettings = {
  refreshCooldownMs: 2000,
  showFirestoreIds: false,
  requestStallMs: 1000,
};

export interface AppSettingsService {
  settings$: Observable<AppSettings>;
  getSettings(): AppSettings;
  applySettings(settings: AppSettings): void;
}

export const APP_SETTINGS_TOKEN = new InjectionToken<AppSettingsService>('APP_SETTINGS_TOKEN');
